import Swiper from 'swiper/bundle';

export default class Carousel {
  constructor(element) {
    this.element = element;

    this.options = {
      slidesPerView: 1,
      spaceBetween: 20,
      allowTouchMove: false,

      breakpoints: {
        769: {
          slidesPerView: 2,
        },
      },

      pagination: {
        el: this.element.querySelector('.swiper-pagination'),
        type: 'bullets',
        clickable: true,
      },

      navigation: {
        prevEl: this.element.querySelector('.swiper-button-prev'),
        nextEl: this.element.querySelector('.swiper-button-next'),
      },

      coverflowEffect: {
        rotate: 0,
        slideShadows: false,
        modifier: 0,
      },
    };

    this.init();
  }

  init() {
    this.setOptions();
    this.viewportWidth = window.width;
    new Swiper(this.element, this.options);
  }

  setOptions() {
    if ('loop' in this.element.dataset) {
      this.options.loop = true;
    }

    if ('coverflow' in this.element.dataset) {
      this.options.effect = 'coverflow';
      this.options.slidesPerView = 1;
      this.options.centeredSlides = true;
      this.options.initialSlide = 2;
      this.options.spaceBetween = 0;

      this.options.breakpoints = {
        769: {
          slidesPerView: 2,
          coverflowEffect: {
            rotate: 0,
            slideShadows: false,
            modifier: 5,
          },
        },
      };

      /*if(this.viewportWidth <= 768){
        this.options.effect = 'default';
        this.options.slidesPerView = 1;
        this.options.centeredSlides = false;
        console.log('allo');
      }*/
    }
  }
}
